export default function (instance) {
  return {
    newPosts() {
      return instance.post("api/new-posts-api");
    },
  };
}
